import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import(/* webpackChunkName: "index" */ '../views/index/index.vue')
  },
  {
    path: '/business',
    name: 'business',
    component: () => import(/* webpackChunkName: "business" */ '../views/business/business.vue')
  },
  {
    path: '/caidaoApp',
    name: 'caidao-app',
    component: () => import(/* webpackChunkName: "business" */ '../views/caidao-app/caidao-app.vue')
  },
  {
    path: '/shopkeeperHelp',
    name: 'shopkeeper-help',
    component: () => import(/* webpackChunkName: "business" */ '../views/shopkeeper-help/shopkeeper-help.vue')
  },
  {
    path: '/join',
    name: 'join',
    component: () => import(/* webpackChunkName: "join" */ '../views/join/join.vue')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "download" */ '../views/download/download.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const toPath = to.path
  const fromPath = from.path
  if (toPath !== fromPath) {
    store.commit('setActivated', toPath)
    next()
  }
})

export default router
